import api from "../../APIIntercepter";

async function getPastPapersAPI() {
  const res = await api.get("/pastPapers");
  return res.data;
}

async function createPastPaperAPI(params) {
  const res = await api.post("/pastPapers/admin", params);
  return res.data;
}

async function updatePastPaperAPI(params) {
  const res = await api.put("/pastPapers/admin", params);
  return res.data;
}

async function deletePastPaperAPI(pastPaperId) {
  const res = await api.delete("/pastPapers/admin?id=" + pastPaperId);
  return res.data;
}

async function getPastPaperFilesAPI(pastPaperId) {
  const res = await api.get("/pastpaperfiles?id=" + pastPaperId);
  return res.data;
}

async function createPastPaperFilesAPI(params) {
  const res = await api.post("/pastpaperfiles/admin", params);
  return res.data;
}

async function updatePastPaperFilesAPI(params) {
  const res = await api.put("/pastpaperfiles/admin", params);
  return res.data;
}

async function deletePastPaperFilesAPI(id) {
  const res = await api.delete("/pastpaperfiles/admin?id=" + id);
  return res.data;
}

export {
  getPastPapersAPI,
  createPastPaperAPI,
  updatePastPaperAPI,
  deletePastPaperAPI,
  getPastPaperFilesAPI,
  createPastPaperFilesAPI,
  updatePastPaperFilesAPI,
  deletePastPaperFilesAPI,
};
